const ContactMap = {
    template: null,
    coordinates: {
        nitra: {
            Map: [18.01302579658106, 18.0546562199398, 17.99302579658106],
            Contact: [18.01302579658106, 18.0546562199398, 18.02302579658106],
            lat: 48.33442911161556,
            pin: [48.33326920839616, 18.0546562199398]
        },
        bratislava: {
            Map: [17.125002982721816, 17.165002982721816, 17.115002982721816],
            Contact: [17.125002982721816, 17.165002982721816, 17.115002982721816],
            lat: 48.18598446129422,
            pin: [48.185129977909504, 17.167563710421366]
        }
    },

    init() {
        this.section = $('[template="Map"], section[template="Contact"]');
        if (!this.section.length) return;
        this.template = this.section.attr('template');
        this.city = this.section.attr('city');
        this.el = this.section.find('#map')
        this.resize();
    },

    resize() {
        if (!this.el || !this.el.length) return;
        switch (true) {
            case  window.innerWidth < 1000 && window.innerWidth > 750:
                this.lng = this.coordinates[this.city][this.template][0];
                break;
            case  window.innerWidth < 750:
                this.lng = this.coordinates[this.city][this.template][1];
                break;
            default:
                this.lng = this.coordinates[this.city][this.template][2];
        }

        this.lat = this.coordinates[this.city].lat

        this.prepare().then();
    },

    async prepare() {
        console.log()
        const {Map} = await google.maps.importLibrary("maps");
        const map = new Map(this.el[0], {
            center: {
                lat: this.lat,
                lng: this.lng
            },
            zoom: 13,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: true,
            rotateControl: false,
            fullscreenControl: true,
            styles: [...this.styles]
        });

        const svgMarker = {
            url: '/files/map-pin.svg',
            anchor: new google.maps.Point(35, 90),
        };

        new google.maps.Marker({
            position: {lat: this.coordinates[this.city].pin[0], lng: this.coordinates[this.city].pin[1]},
            icon: svgMarker,
            map: map,
        });
    },


    styles: [
        {
            "featureType": "landscape",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "simplified"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "poi",
            "elementType": "labels.text",
            "stylers": [
                {
                    "visibility": "on"
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "geometry",
            "stylers": [
                {
                    "lightness": 57
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.text.fill",
            "stylers": [
                {
                    "visibility": "on"
                },
                {
                    "lightness": 24
                }
            ]
        },
        {
            "featureType": "road",
            "elementType": "labels.icon",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "transit",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        },
        {
            "featureType": "water",
            "elementType": "labels",
            "stylers": [
                {
                    "visibility": "off"
                }
            ]
        }
    ]

}

export default ContactMap;
